import {
  FETCH_UPLOAD_LOGS_REQUEST,
  FETCH_UPLOAD_LOGS_SUCCESS,
  FETCH_UPLOAD_LOGS_FAILURE,
} from './UploadLogsAction';

const initialState = {
  bulk_upload: { logs: [], loading: false, error: null },
  bulk_edit: { logs: [], loading: false, error: null },
  full_length: { logs: [], loading: false, error: null },
};

export default function uploadLogsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_UPLOAD_LOGS_REQUEST:
      return { ...state, [action.folder]: { ...state[action.folder], loading: true, error: null } };
    case FETCH_UPLOAD_LOGS_SUCCESS:
      return { ...state, [action.folder]: { logs: action.payload, loading: false, error: null } };
    case FETCH_UPLOAD_LOGS_FAILURE:
      return { ...state, [action.folder]: { ...state[action.folder], loading: false, error: action.error } };
    default:
      return state;
  }
}
